import { render, staticRenderFns } from "./ApiVersion.vue?vue&type=template&id=366dc5ef"
import script from "./ApiVersion.vue?vue&type=script&lang=js"
export * from "./ApiVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports